// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__k2ohw","mainBackground":"Layout_mainBackground__WwF_D","customBackground":"Layout_customBackground__WWMk9"};